module.exports = __webpack_public_path__ + "img/47400.38752a1e.jpg";